import { ILang, Nav, OnAnalyticsRequestCallbackType, OnLogoutRequestCallbackType } from "@dietdoctor/elements";
import "@dietdoctor/elements/build/style.css";
import React, { useCallback, useContext } from "react";
import { useOptimisticNavUser } from "../../hooks/useOptimisticNavUser/useOptimisticNavUser";
import { useUser } from "../../hooks/useUser/useUser";
import { LoginPage } from "../../pages";
import { sendEvent } from "../../utils/gtm";
import { useNavigate } from "../Link/Link";
import { pageContext } from "../PageProvider/PageProvider";

const NavigationBar: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { locale } = useContext(pageContext);
  const { user, loading, send } = useUser(() =>
    navigate({
      to: LoginPage,
      query: {
        redirectTo: document.location.href,
      },
    })
  );

  const onLogoutRequestCallback: OnLogoutRequestCallbackType = useCallback(async () => {
    send("LOG_OUT");
  }, [send]);

  const onAnalyticsRequestCallback: OnAnalyticsRequestCallbackType = useCallback((label: string) => {
    sendEvent({
      eventName: "navbar",
      action: "Click",
      payload: { label },
    });
  }, []);

  const optimisticUser = useOptimisticNavUser();

  /*
   * Show the optimistic user only while the authoritative check is still running. Once it has
   * resolved, its answer is the only one: a session that died elsewhere resolves to logged out,
   * and the nav must return to anonymous rather than keep showing stale member chrome.
   */
  const navUser = user ?? (loading ? optimisticUser : undefined);

  const lang = locale as unknown as ILang;

  return (
    <div id="header" className="h-14 print:hidden">
      <Nav
        lang={lang}
        user={navUser}
        onLogoutRequestCallback={onLogoutRequestCallback}
        onAnalyticsRequestCallback={onAnalyticsRequestCallback}
      />
    </div>
  );
};

export { NavigationBar };
